import { useEffect, useRef, useState } from 'react';

export const useScrollAnimation = (threshold = 0.1) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false); // Track if element was ever visible
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setHasBeenVisible(true);
          // Una vez visible, desconectar el observador para que no se reinicie
          observer.disconnect();
        }
        // Quitamos el reset de visibilidad para que no se repita la animación
      },
      {
        threshold,
        rootMargin: '-50px 0px',
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };  }, [threshold]);

  return [ref, isVisible, hasBeenVisible];
};
